import { ActionType } from '@/actions';
import { ActionSetCouponNumbers, ActionToggleCouponNumber } from './interfaces';

export const setCouponNumbers = (
  game: number,
  coupon: number,
  group: number,
  values: number[]
): ActionSetCouponNumbers => {
  return {
    type: ActionType.COUPON_NUMBERS_SET,
    game,
    coupon,
    group,
    values,
  };
};

export const toggleCouponNumber = (
  game: number,
  coupon: number,
  group: number,
  value: number
): ActionToggleCouponNumber => {
  return {
    type: ActionType.COUPON_NUMBER_TOGGLED,
    game,
    coupon,
    group,
    value,
  };
};
